import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

/** Inline request feedback; the feature owns requests, retained data and retry policy. */
@Component({
  selector:'app-load-state',standalone:true,imports:[CommonModule],
  templateUrl:'./load-state.component.html',styleUrls:['./load-state.component.scss']
})
export class LoadStateComponent {
  @Input() pending=false;
  @Input() error='';
  @Input() message='';
  @Input() loadingText='Loading…';
  @Input() retryLabel='Try again';
  @Input() retryDisabled=false;
  @Output() retry=new EventEmitter<void>();
  @ViewChild('notice') private notice:ElementRef<HTMLElement>;

  requestRetry():void {
    if(this.pending||this.retryDisabled||!this.error)return;
    this.notice?.nativeElement.focus({preventScroll:true});
    this.retry.emit();
  }
}
